(function() {
  var COLORS = [
    ['midnight navy', '#10182D'],
    ['dark heather', '#606060'],
    ['heather gray', '#A1A1A1'],
    ['heather grey', '#A1A1A1'],
    ['heather', '#A1A1A1'],
    ['military green', '#4A5B3A'],
    ['forest green', '#1F3B24'],
    ['flo blue', '#4EB0E8'],
    ['indigo blue', '#2E3A88'],
    ['light pink', '#F6C5D3'],
    ['light blue', '#7BB5DF'],
    ['true navy', '#0C447C'],
    ['navy', '#0C447C'],
    ['royal', '#1F4C99'],
    ['indigo', '#2E3A88'],
    ['forest', '#1F3B24'],
    ['military', '#4A5B3A'],
    ['watermelon', '#E4586F'],
    ['charcoal', '#2C2C2A'],
    ['butter', '#F4D06F'],
    ['cream', '#F4EFE3'],
    ['natural', '#F4EFE3'],
    ['beige', '#E8DDC2'],
    ['sand', '#E5D5B0'],
    ['brown', '#5A3A22'],
    ['silver', '#C0C0C0'],
    ['gold', '#C9A227'],
    ['orange', '#EF6C1A'],
    ['yellow', '#F2C94C'],
    ['purple', '#7F77DD'],
    ['pink', '#F4A6C0'],
    ['green', '#3B6D11'],
    ['blue', '#185FA5'],
    ['red', '#E63946'],
    ['black', '#0A0A0A'],
    ['white', '#FFFFFF'],
    ['grey', '#888780'],
    ['gray', '#888780']
  ];

  function resolveColor(name) {
    if (!name) return null;
    var lower = String(name).toLowerCase();
    for (var i = 0; i < COLORS.length; i++) {
      if (lower.indexOf(COLORS[i][0]) !== -1) return { name: COLORS[i][0], hex: COLORS[i][1] };
    }
    return null;
  }

  function paintLabel(label, fs) {
    var input = label.querySelector('input[type="radio"]');
    if (!input) return;
    var val = input.value || input.getAttribute('aria-label') || '';
    var c = resolveColor(val);
    if (!c) return; // don't touch non-color labels

    // Force styles inline so we beat any Horizon reset
    var s = label.style;
    s.setProperty('width', '30px', 'important');
    s.setProperty('height', '30px', 'important');
    s.setProperty('min-width', '30px', 'important');
    s.setProperty('min-height', '30px', 'important');
    s.setProperty('max-width', '30px', 'important');
    s.setProperty('max-height', '30px', 'important');
    s.setProperty('flex', '0 0 30px', 'important');
    s.setProperty('padding', '0', 'important');
    s.setProperty('border-radius', '50%', 'important');
    s.setProperty('background-color', c.hex, 'important');
    s.setProperty('background-clip', 'padding-box', 'important');
    s.setProperty('overflow', 'hidden', 'important');
    s.setProperty('position', 'relative', 'important');
    s.setProperty('cursor', 'pointer', 'important');
    s.setProperty('aspect-ratio', '1 / 1', 'important');
    s.setProperty('margin', '3px', 'important');
    s.setProperty('box-shadow', 'none', 'important');
    if (c.name === 'white' || c.name === 'cream' || c.name === 'natural' || c.name === 'butter' || c.name === 'sand' || c.name === 'beige') {
      s.setProperty('border', '1px solid rgba(10,10,10,0.35)', 'important');
    } else {
      s.setProperty('border', '1px solid rgba(10,10,10,0.20)', 'important');
    }

    label.classList.add('sr-swatch');
    label.setAttribute('title', val);
    label.setAttribute('aria-label', val);

    // Hide the inner text/pill spans no matter what Horizon does
    var spans = label.querySelectorAll('.variant-option__button-label__pill, .variant-option__button-label__text');
    spans.forEach(function(sp) {
      sp.style.setProperty('display', 'none', 'important');
    });

    // Reflect selection state
    if (input.checked) {
      label.style.setProperty('box-shadow', '0 0 0 2px #F6EFDD, 0 0 0 4px #0A0A0A', 'important');
      label.classList.add('is-selected');
    } else {
      label.classList.remove('is-selected');
    }

    if (!label.dataset.srBound) {
      input.addEventListener('change', function() {
        // Repaint all labels in the same fieldset so selection ring updates
        fs.querySelectorAll('label.variant-option__button-label').forEach(function(l) { paintLabel(l, fs); });
      });
      label.dataset.srBound = '1';
    }
  }

  function paintFieldset(fs) {
    if (!fs) return;
    var oid = (fs.getAttribute('data-option-id') || '').toLowerCase();
    var legend = fs.querySelector('legend');
    var legendText = legend ? (legend.textContent || '').toLowerCase() : '';
    var isColorFs =
      oid.indexOf('color') !== -1 ||
      oid.indexOf('colour') !== -1 ||
      legendText.indexOf('color') !== -1 ||
      legendText.indexOf('colour') !== -1;
    if (!isColorFs) return;

    fs.classList.add('sr-swatch-fs');
    fs.style.setProperty('display', 'flex', 'important');
    fs.style.setProperty('flex-wrap', 'wrap', 'important');
    fs.style.setProperty('gap', '8px', 'important');
    fs.style.setProperty('grid-template-columns', 'none', 'important');

    var labels = fs.querySelectorAll('label.variant-option__button-label');
    labels.forEach(function(label) { paintLabel(label, fs); });
  }

  function paintCardDots() {
    document.querySelectorAll('.cx-card__swatch[data-color], .shop-card__swatch[data-color]').forEach(function(dot) {
      if (dot.dataset.srPainted === '1') return;
      var c = resolveColor(dot.getAttribute('data-color'));
      if (c) {
        dot.style.setProperty('background-color', c.hex, 'important');
        if (c.name === 'white' || c.name === 'cream' || c.name === 'natural' || c.name === 'butter' || c.name === 'sand' || c.name === 'beige') {
          dot.style.setProperty('border-color', 'rgba(10,10,10,0.35)', 'important');
        }
        dot.dataset.srPainted = '1';
      }
    });
  }

  function paintAll() {
    document.querySelectorAll('variant-picker fieldset').forEach(paintFieldset);
    paintCardDots();
  }

  // Aggressive paint schedule: run on multiple ticks to beat Horizon's variant-picker init
  function schedulePaints() {
    paintAll();
    requestAnimationFrame(paintAll);
    setTimeout(paintAll, 60);
    setTimeout(paintAll, 200);
    setTimeout(paintAll, 500);
    setTimeout(paintAll, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePaints);
  } else {
    schedulePaints();
  }
  window.addEventListener('load', paintAll);

  // Observe document.body for any variant-picker mount / re-render
  var paintQueued = false;
  var mo = new MutationObserver(function() {
    if (paintQueued) return;
    paintQueued = true;
    requestAnimationFrame(function() { paintQueued = false; paintAll(); });
  });
  function attach() {
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
